import { Component, ElementRef, ViewChild, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, AfterViewInit } from '@angular/core';

import * as fromRulesModel from '@app/models/rules';

@Component({
    selector: 'settings-rules-rule-form-helper-search-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class RulesHelpersSearchMainComponent implements OnInit, OnChanges, AfterViewInit{
    @ViewChild('mySearchRulesTerm') myTermInput: ElementRef;

    @Input() term: string = '';
    @Input() variable: fromRulesModel.AvailableRuleConditionVariable | fromRulesModel.AvailableRuleActionVariable;
    @Input() result: fromRulesModel.RuleActionParameterType;
    @Input() found: Array<fromRulesModel.AvailableRuleItem>;
    @Input() multipleValues: boolean = true; // config if we accept multiple values

    @Output() removeFilter = new EventEmitter<fromRulesModel.AvailableRuleConditionValueItem>();
    @Output() termChanges = new EventEmitter<string>();
    @Output() selectedChanges = new EventEmitter<Array< fromRulesModel.AvailableRuleItem>>();

    public placeholder: string = 'Type your search here.';
    public selected: Array< fromRulesModel.AvailableRuleActionVariableValueItem> = []; 
    public variableValues: Array<fromRulesModel.AvailableRuleActionVariableValueItem>;

    ngOnInit(): void {
        this.selected = this.getSelectedItems();
        this.variableValues = this.getAvailableValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // update variableValues to display only found items on the selector or whatever
        // also open the selector if collapsed
        if(changes.found){
            if(this.found?.length > 0){
                this.variableValues = this.getAvailableValues();
            }
        }
        if(changes.result){
            this.selected = this.getSelectedItems();
        }
    }

    ngAfterViewInit() {
        // Set focus on the input element when the component is reloaded after search
        if(this.found?.length > 0)
            this.myTermInput.nativeElement.focus();
      }

    // emit allwayys when we work with multiple values or not 
    onRemove(filter: fromRulesModel.AvailableRuleConditionValueItem){
        this.removeFilter.emit(filter);
    }

    onTermChanges(term: string) {
        this.termChanges.emit(term);
    }

    
    onSelectRuleItem(item: fromRulesModel.AvailableRuleActionVariableValueItem){
        const newSelectedValue = this.variable.values.filter((vv: fromRulesModel.AvailableRuleActionVariableValueItem) => vv.key == item.key);
        if(this.multipleValues)
            this.selected.push(newSelectedValue[0]);
        else 
            this.selected = newSelectedValue; // need to be array
        // we need to emit the change
        this.selectedChanges.emit(this.selected);

    }

    removeItem(item: fromRulesModel.AvailableRuleActionVariableValueItem) {
        // quit the removed element from selected and emit changes
        this.selected = this.selected.filter((vv: fromRulesModel.AvailableRuleActionVariableValueItem) => vv.key != item.key)
        this.selectedChanges.emit(this.selected);
    }

    getAvailableValues() : Array<fromRulesModel.AvailableRuleActionVariableValueItem> {
        if(this.variable.values && this.term == '')
            return this.variable.values;
        // if there are found items filter the available variable values according found
        const filtered = this.variable.values.filter((val: fromRulesModel.AvailableRuleActionVariableValueItem) => this.found.some((fval:fromRulesModel.AvailableRuleItem) => fval.key == val.key));
        return filtered;
    }

    // We need to check if result includes values. result could be an array string[] | number[]  or a single string | number
    getSelectedItems() : Array< fromRulesModel.AvailableRuleActionVariableValueItem>{
        return this.variable.values.filter((vv: fromRulesModel.AvailableRuleActionVariableValueItem) => {
            if (Array.isArray(this.result)) {
                return this.result.some((item) => item === vv.key || item.toString() === vv.key.toString());
            } else {
                return vv.key.toString() == this.result.toString()
            }
        });
    }


}